import { render, staticRenderFns } from "./area-authorization.vue?vue&type=template&id=076383ac"
import script from "./area-authorization.vue?vue&type=script&lang=js"
export * from "./area-authorization.vue?vue&type=script&lang=js"
import style0 from "./area-authorization.vue?vue&type=style&index=0&id=076383ac&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports